import React from 'react';

export default function TopThreatSources() {
  const threatSources = [
    { source: "External IPs", count: 47, percentage: 35 },
    { source: "Malicious Email", count: 32, percentage: 24 },
    { source: "Insider Threat", count: 21, percentage: 16 },
    { source: "Malware", count: 18, percentage: 13 },
    { source: "Phishing", count: 16, percentage: 12 }
  ];

  return (
    <div className="threat-sources">
      <div className="threat-sources__header">
        <h3 className="threat-sources__title">Top Threat Sources</h3>
        <p className="threat-sources__subtitle">Most common sources of security threats</p>
      </div>
      <div className="threat-sources__list">
        {threatSources.map((source, index) => (
          <div key={source.source} className="threat-source-item">
            <div className="threat-source-item__left">
              <div className="threat-source-item__number">{index + 1}</div>
              <span className="threat-source-item__name">{source.source}</span>
            </div>
            <div className="threat-source-item__right">
              <div className="threat-source-item__progress">
                <div className="threat-source-item__bar">
                  <div 
                    className="threat-source-item__fill" 
                    style={{ width: `${source.percentage}%` }}
                  ></div>
                </div>
                <span className="threat-source-item__percentage">{source.percentage}%</span>
              </div>
              <div className="threat-source-item__count">{source.count}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
